export default __webpack_public_path__ + "static/media/logo-right.97a30de8.webp";